/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_FetchHistoryQueryVariables = Types.Exact<{
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  afterCursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type MentorDash_FetchHistoryQuery = {
  __typename?: 'Query';
  queue?: {
    __typename?: 'Queue';
    history?: {
      __typename?: 'QueueActionHistorySearch';
      totalCount: number;
      edges: Array<{
        __typename?: 'QueueActionHistorySearchResult';
        cursor?: string | null;
        node?:
          | {
              __typename?: 'QueueActionAnswer';
              createdAt: any;
              type: Types.QueueActionType;
              project: { __typename?: 'QueueProject'; title: string };
              payment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
              question: { __typename?: 'Question'; id: any };
            }
          | {
              __typename?: 'QueueActionComment';
              createdAt: any;
              type: Types.QueueActionType;
              project: { __typename?: 'QueueProject'; title: string };
              payment: { __typename?: 'Money'; amount: any; currencyCode?: string | null };
              question: { __typename?: 'Question'; id: any };
            }
          | null;
      }>;
    } | null;
  } | null;
};

export const MentorDash_FetchHistoryDocument = `
    query MentorDash_FetchHistory($count: Int, $afterCursor: String) {
  queue {
    history(first: $count, after: $afterCursor) {
      edges {
        cursor
        node {
          project {
            title
          }
          createdAt
          payment {
            amount
            currencyCode
          }
          type
          question {
            id
          }
        }
      }
      totalCount
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_FetchHistory: build.query<MentorDash_FetchHistoryQuery, MentorDash_FetchHistoryQueryVariables | void>({
      query: (variables) => ({ document: MentorDash_FetchHistoryDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
